import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-layout',[_c(VFlex,{attrs:{"xs12":""}},[_c(VContainer,{staticClass:"py-0 elevation-1 white",attrs:{"fluid":""}},[_c(VTabs,{attrs:{"slider-color":"primary"}},_vm._l((_vm.items),function(item){return _c(VTab,{key:item.route.name,attrs:{"to":item.route}},[_vm._v(_vm._s(item.text))])}),1)],1),_c(VContainer,{attrs:{"fluid":""}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }